









import Vue from 'vue';

export default Vue.extend({
  props: {
    duration: {
      default: 6000,
    },
  },

  data: () => ({
    currentError: {
      message: '',
      active: false,
    },
  }),

  mounted() {
    if (this.$store.state.errorMessage) {
      this.setMessage(this.$store.state.errorMessage);
    }

    this.$store.subscribe((mutation, state) => {
      if ((mutation.type === 'errorMessage') && (typeof state.errorMessage !== 'undefined')) {
        this.setMessage(state.errorMessage);
      }
    });
  },

  methods: {
    setMessage(message) {
      this.currentError.active = true;
      this.currentError.message = message;
    },

    resetMessage() {
      this.currentError.active = false;
      this.currentError.message = '';

      this.$store.commit('errorMessage', undefined);
    },
  },
});
